// Oturum açmış kullanıcının gezdiği sayfaları işlem kaydına bildirir.
// Hızlı sayfa geçişlerinde yalnızca kalınan sayfa bildirilir; yayın kaplamaları
// (OBS) kaydedilmez.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useUser } from "../UserContext";
import { isOverlayPath } from "../appShell";
import { reportPageView } from "../services/activityLogApi";

const SETTLE_MS = 1200;

export default function PageViewTracker() {
  const { user } = useUser();
  const location = useLocation();
  const userId = user?.id;

  useEffect(() => {
    if (!userId || isOverlayPath(location.pathname)) return undefined;
    // Ziyaretçi analizindeki ısı haritası önizlemesi (iframe) kayıt üretmesin.
    try {
      if (window.top !== window.self) return undefined;
    } catch {
      return undefined;
    }
    const path = `${location.pathname}${location.search || ""}`;
    const timer = setTimeout(() => reportPageView(path, document.title || ""), SETTLE_MS);
    return () => clearTimeout(timer);
  }, [userId, location.pathname, location.search]);

  return null;
}
